import Angular from "angular";

let LoadingInterceptorModule = Angular.module('LoadingInterceptor', []);

export const DataLoadingEvent = {
    Start: '$dataLoading:start',
    Stop: '$dataLoading:stop',
    Error: '$dataLoading:error'
};

LoadingInterceptorModule.factory('LoadingInterceptor', ['$q', '$rootScope', '$injector', function ($q, $rootScope, $injector) {
    return {
        request: function (config) {
            if (config.url.startsWith('http://')) {
                let $http = $http || $injector.get('$http');
                if ($http.pendingRequests.length === 0) {
                    $rootScope.$broadcast(DataLoadingEvent.Start);
                    $rootScope.$dataLoading = true;
                }
            }

            return config || $q.when(config);
        },

        response: function (response) {
            if (response.config.url.startsWith('http://')) {
                let $http = $http || $injector.get('$http');
                if ($http.pendingRequests.length === 0) {
                    $rootScope.$broadcast(DataLoadingEvent.Stop);
                    $rootScope.$dataLoading = false;
                }
            }

            return response;
        },

        requestError: function (rejection) {
            if (rejection.url.startsWith('http://')) {
                $rootScope.$broadcast(DataLoadingEvent.Error);

                let $http = $http || $injector.get('$http');
                if ($http.pendingRequests.length === 0) {
                    $rootScope.$broadcast(DataLoadingEvent.Stop);
                    $rootScope.$dataLoading = false;
                }
            }

            return $q.reject(rejection);
        },

        responseError: function (rejection) {
            if (rejection.config.url.startsWith('http://')) {
                $rootScope.$broadcast(DataLoadingEvent.Error);

                let $http = $http || $injector.get('$http');
                if ($http.pendingRequests.length === 0) {
                    $rootScope.$broadcast(DataLoadingEvent.Stop);
                    $rootScope.$dataLoading = false;
                }
            }

            return $q.reject(rejection);
        }
    }

}]);

export default LoadingInterceptorModule;



// WEBPACK FOOTER //
// ./src/modules/core/interceptors/loading.interceptor.js